import React from 'react';
import { makeStyles, Typography, Card, CardContent } from '@material-ui/core';

import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-moment';
import { ResolutionEnumDto } from '.generated/api';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  chartContainer: {
    height: '10%',
    position: 'relative',
    flex: 1,
  },
}));

interface VolumeCardProps {
  values: number[];
  dates: Date[];
  minDate: Date;
  maxDate: Date;
  className?: string;
  resolution?: ResolutionEnumDto;
}

const VolumeCard: React.FC<VolumeCardProps> = ({
  values,
  dates,
  minDate,
  maxDate,
  className,
  resolution,
}) => {
  const classes = useStyles();

  maxDate.setMinutes(0);
  minDate.setMinutes(0);
  maxDate.setSeconds(0);
  minDate.setSeconds(0);

  let unit: string | undefined;
  let tooltipFormat: string | undefined;
  switch (resolution) {
    case ResolutionEnumDto.HOURLY:
      unit = 'hour';
      tooltipFormat = 'hA';
      minDate.setHours(0);
      maxDate.setHours(24);
      break;
    case ResolutionEnumDto.DAILY:
      unit = 'day';
      tooltipFormat = 'MMM DD';
      maxDate.setHours(0);
      minDate.setHours(0);
      break;
    case ResolutionEnumDto.MONTHLY:
      unit = 'month';
      tooltipFormat = 'MMM YYYY';
      maxDate.setHours(0);
      maxDate.setDate(1);
      minDate.setHours(0);
      minDate.setDate(1);
      break;
  }

  const data = {
    labels: [minDate, ...dates, maxDate],
    datasets: [
      {
        data: [0, ...values, 0],
        pointRadius: 0,
        backgroundColor: 'rgba(0,166,75,1)',
        borderWidth: 0,
        barThickness: 60,
      },
    ],
  };

  const options = {
    animation: false as const,
    scales: {
      xAxes: {
        type: 'time' as const,
        time: {
          tooltipFormat: tooltipFormat,
          unit,
          unitStepSize: 1,
          min: minDate,
          max: maxDate,
        },
      },
    },

    plugins: {
      legend: { display: false },
    },
    maintainAspectRatio: false,
  };

  return (
    <Card className={className}>
      <CardContent className={classes.content}>
        <Typography variant="h2" gutterBottom>
          Volume
        </Typography>
        <div className={classes.chartContainer}>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {values.length > 0 && <Bar data={data} options={options as any} />}
        </div>
      </CardContent>
    </Card>
  );
};

export default VolumeCard;
